export default {
    computed: {
        statusList () {
            return [{
                label: this.$t('fbb.accountmanage.active',{defaultValue:'启用'}),
                color: 'color-success',
                value: 1
            }, {
                label: this.$t('fbb.accountmanage.disable',{defaultValue:'禁用'}),
                color: 'color-default',
                value: 0
            }]
        },
        sfpList () {
            return [{
                label: this.$t('erp.global.yes',{defaultValue:'是'}),
                value: 1
            }, {
                label: this.$t('erp.global.no',{defaultValue:'否'}),
                value: 0
            }]
        },
        indexShowList () {
            return [{
                type: 1
            }, {
                type: 2
            }, {
                type: 3
            }, {
                type: 4
            }]
        },
        typeList() {
            return [
                {
                    type: 1,
                    theme: "error",
                    title: this.$t('erp.rules.highware',{defaultValue:'高优先级仓库（需要优先发货的仓库）'}),
                    ruleType: 1,
                    sortorder: 9
                },
                {
                    type: 2,
                    theme: "primary",
                    title: this.$t('erp.rules.normalware',{defaultValue:'普通优先级仓库'}),
                    desc: this.$t('erp.rules.normalware_tip',{defaultValue:'高优先级、低优先级、黑名单仓库之外的所有服务仓和虚拟仓默认都是普通优先级，不需要单独设置规则'}),
                    ruleType: 1,
                    sortorder: 0
                },
                {
                    type: 3,
                    theme: "success",
                    title: this.$t('erp.rules.lowware',{defaultValue:'低优先级仓库（需要最后发货的仓库）'}),
                    ruleType: 1,
                    sortorder: -1
                },
                {
                    type: 4,
                    theme: "gray",
                    title: this.$t('erp.rules.blackware',{defaultValue:'黑名单仓库（不可以发货的仓库）'}),
                    ruleType: 2
                },
                {
                    // 人工审核
                    type: 5,
                    ruleType: 3
                }
            ];
        },
    }
}